import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20vibrant%20abstract%20background%20with%20comic%20book%20style%20pop%20art%20elements%2C%20halftone%20dots%2C%20burst%20shapes%2C%20dynamic%20energy%20waves%20in%20orange%20and%20coral%20tones%2C%20warm%20gradient%20atmosphere%2C%20modern%20illustration%20style%2C%20no%20text%2C%20clean%20abstract%20composition&width=1800&height=900&seq=hero-bg-comic-01&orientation=landscape"
        alt="香蕉漫画 - 漫画推荐背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/60 via-background-950/40 to-background-950/60"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 mb-6 leading-tight">
          发现你的<span className="text-secondary-400">下一部</span>最爱漫画
        </h1>
        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-10 leading-relaxed">
          香蕉漫画精选热门韩漫、日漫、国漫分类推荐，涵盖恋爱、奇幻、热血等所有风格，为漫迷提供高清漫画免费在线阅读和人气排行榜。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
          <Link
            to="/category/korean"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-bold text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            开始探索
          </Link>
          <Link
            to="/#rankings"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50/15 text-background-50 font-bold text-base border border-background-50/30 hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看排行榜
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 max-w-4xl mx-auto">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm transition-all duration-300 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-500 text-background-50 group-hover:scale-110 transition-transform">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-background-50 whitespace-nowrap">{cat.name}</span>
            </Link>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}